// 安卓 WebView 专用图片加载函数
export const loadImageForAndroid = async (src: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    // 安卓 WebView 特殊设置
    img.crossOrigin = 'anonymous';

    // 增加超时时间
    const timeout = setTimeout(() => {
      reject(new Error('安卓图片加载超时'));
    }, 20000); // 20秒超时

    img.onload = () => {
      clearTimeout(timeout);

      // 安卓 WebView 可能需要额外的处理
      try {
        // 创建 canvas 重新绘制图片，避免直接使用
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        if (ctx) {
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          ctx.drawImage(img, 0, 0);

          // 转换为 data URL
          const dataUrl = canvas.toDataURL();
          resolve(dataUrl);
        } else {
          resolve(img.src);
        }
      } catch (error) {
        console.warn('安卓图片处理失败，使用原图:', error);
        resolve(img.src);
      }
    };

    img.onerror = () => {
      clearTimeout(timeout);
      reject(new Error('安卓图片加载失败'));
    };

    // 添加随机参数避免缓存问题
    const separator = src.includes('?') ? '&' : '?';
    const cacheBuster = `_t=${Date.now()}`;
    img.src = `${src}${separator}${cacheBuster}`;
  });
};
